'use strict';
const ansiRegex = require('ansi-regex');

module.exports = string => typeof string === 'string' ? string.replace(ansiRegex(), '') : string;



//////////////////
// WEBPACK FOOTER
// (webpack)-hot-middleware/~/strip-ansi/index.js
// module id = 802
// module chunks = 0